export const REQUIRED_FIELD_MESSAGE = 'This field is required';
export const INCORRECT_EMAIL_FORMAT_MESSAGE = 'Email format is incorrect';
